var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConeFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9651 21.7951C11.365 22.0956 10.6521 22.0639 10.0811 21.7112C9.51029 21.3591 9.16242 20.7366 9.16168 20.0659V12.804L4.56779 8.20692C4.20468 7.84427 4.00045 7.35227 4 6.83908V3.93563C4 2.86661 4.86661 2 5.93563 2H18.8398C19.9089 2 20.7755 2.86661 20.7755 3.93563V6.83908C20.775 7.35227 20.5708 7.84427 20.2077 8.20692L15.6138 12.804V18.7755C15.6134 19.5074 15.2002 20.1765 14.546 20.5046L11.9651 21.7951ZM5.93563 3.93563V6.83908L11.0973 12.0008V20.0659L13.6782 18.7755V12.0008L18.8398 6.83908V3.93563H5.93563Z",
    fill: "#516179"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConeFilter);
export default __webpack_public_path__ + "static/media/cone-filter.abe6c94f1aece6ca9a802428b46732b1.svg";
export { ForwardRef as ReactComponent };